import React, { Fragment } from "react";
import { number, object, oneOfType, shape, string } from "prop-types";
import { Button, Card, Modal, Spinner } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { changeCourseStatusAction } from "@redux/actions";
import styles from "./styles/EditModal.module.css";

const EditModal = ({ data, handleClose }) => {
  // state

  // variables
  let spinner = null;
  let spinnerVisible = false;
  const { id, title, user, createdAt, category, status } = data;
  let statusName;
  let statusVariant;
  switch (status) {
    case 0:
      statusName = "Pending";
      statusVariant = "primary";
      break;
    case 1:
      statusName = "Approved";
      statusVariant = "success";
      break;
    case 2:
      statusName = "Rejected";
      statusVariant = "warning";
      break;
    case 3:
      statusName = "Blocked";
      statusVariant = "danger";
      break;
  }

  // logics before hooks

  // hooks
  const { courseStatusChanger } = useSelector((state) => state.course);
  spinnerVisible = courseStatusChanger.processing;
  const dispatch = useDispatch();

  // logics
  const handleChangeStatus = (newStatus) => {
    dispatch(
      changeCourseStatusAction({
        data: [id, newStatus],
        onSuccess: () => handleClose(),
      })
    );
  };

  // UI partials
  if (spinnerVisible)
    spinner = (
      <div className={styles.spinner}>
        <div className="text-center">
          <Spinner animation="border" variant="danger" />
          <div className="text-danger">Processing...</div>
        </div>
      </div>
    );

  // effects

  // render
  return (
    <Fragment>
      <Modal.Header closeButton>
        <Modal.Title>Update Course Status</Modal.Title>
      </Modal.Header>
      <Modal.Body className="position-relative">
        {spinner}
        <Card.Body className="p-0">
          <Card.Title>
            <strong className={`text-${statusVariant} mr-2`}>
              ({statusName})
            </strong>
            {title}
          </Card.Title>
          <Card.Subtitle className="mb-2 text-muted">
            Created by{" "}
            <Link to={"/"} className="text-decoration-none">
              {user.fullName}
            </Link>{" "}
            at {`${moment(createdAt).format("HH:mm - DD MMMM YYYY")}`}
          </Card.Subtitle>
          <Link to={"/"} className="text-decoration-none">
            {category.name}
          </Link>
        </Card.Body>
      </Modal.Body>
      <Modal.Footer>
        {status === 0 ? (
          <Fragment>
            <Button
              disabled={courseStatusChanger.processing}
              variant="success"
              onClick={() => handleChangeStatus(1)}
            >
              Approve
            </Button>
            <Button
              disabled={courseStatusChanger.processing}
              variant="primary"
              onClick={() => handleChangeStatus(2)}
            >
              Reject
            </Button>
          </Fragment>
        ) : null}
        {status === 1 ? (
          <Fragment>
            <Button
              disabled={courseStatusChanger.processing}
              variant="primary"
              onClick={() => handleChangeStatus(3)}
            >
              Block
            </Button>
            <Button
              disabled={courseStatusChanger.processing}
              variant="primary"
              onClick={() => handleChangeStatus(2)}
            >
              Reject
            </Button>
          </Fragment>
        ) : null}
        {status === 2 ? (
          <Button
            disabled={courseStatusChanger.processing}
            variant="success"
            onClick={() => handleChangeStatus(1)}
          >
            Approve
          </Button>
        ) : null}
        {status === 3 ? (
          <Button
            disabled={courseStatusChanger.processing}
            variant="success"
            onClick={() => handleChangeStatus(1)}
          >
            Unblock
          </Button>
        ) : null}
      </Modal.Footer>
    </Fragment>
  );
};

/* required: display name */
EditModal.displayName = "EditModal";

/* required: props types */
EditModal.propTypes = {
  data: shape({
    id: string,
    title: string,
    user: shape({ id: string, fullName: string }),
    createdAt: oneOfType([string, object]),
    category: shape({ name: string, id: string }),
    status: number,
  }),
};

/* required: default props */
EditModal.defaultProps = {
  data: {
    id: "",
    title: "",
    user: { id: "", fullName: "" },
    createdAt: moment(),
    category: { name: "", id: "" },
    status: 0,
  },
};

export { EditModal };
